import type { AlertPosterProps } from './AlertPoster.d';
import React, {type JSX} from 'react';
import { render } from 'react-dom';


export function printComponent({
	component,
	title,
}: {
	component: JSX.Element;
	title: string;
}): Promise<void> {
	return new Promise((resolve) => {
		const iframe = document.createElement('iframe');
		iframe.style.display = 'none';
		iframe.style.width = '100vw'; // Set width to full viewport width
		iframe.style.height = '100vh'; // Set height to full viewport height
		iframe.style.position = 'absolute'; // Ensure it doesn't affect layout
		iframe.style.top = '0';
		iframe.style.left = '0';
		document.body.appendChild(iframe);

		if (!iframe.contentWindow) {
			throw new Error(`iframe.contentWindow is falsy!`);
		}

		// iframe.onload = () => {
		// 	console.debug('iframe onload never happens!');
		// };

		const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

		// Set the iframe document title
		const titleEl = iframeDoc.createElement('title');
		titleEl.textContent = title; // Set your desired title here
		iframeDoc.head.appendChild(titleEl);

		//  Copy stylesheets from the main document
		const styleSheets = Array.from(document.styleSheets);
		styleSheets.forEach((sheet) => {
			try {
				// For external stylesheets
				if (sheet.href) {
					const link = iframeDoc.createElement('link');
					link.rel = 'stylesheet';
					link.href = sheet.href;
					iframeDoc.head.appendChild(link);
				} else {
					// For inline <style> tags
					const style = iframeDoc.createElement('style');
					style.textContent = Array.from(sheet.cssRules)
						.map((rule) => rule.cssText)
						.join('\n');
					iframeDoc.head.appendChild(style);
				}
			} catch (e) {
				console.warn('Could not copy stylesheet:', e);
			}
		});

		// Add custom styles for print, including landscape orientation and Font Awesome fix
		const customStyle = iframeDoc.createElement('style');

		// NOTE: This needs sha256 in CSP!
		customStyle.textContent = `
	@page {
		size: A4 landscape;
		/* margin: 0.4in; Browsers should fallback to this when not specified. */
	}
	/* @media print {
		img { display: block; }
	} */
	body {
		margin: 0;
		width: 100%;
		height: 100%;
		font-size: 16px;
	}
	#print-root {
		width: 100%;
		height: 100%;
	}`;
		iframeDoc.head.appendChild(customStyle);

		iframeDoc.body.innerHTML = '<div id="print-root"></div>';

		const rootElement = iframeDoc.getElementById('print-root');

		const hasImage = !!(component.props as AlertPosterProps).imgSrc;

		// Define print and cleanup logic
		const triggerPrint = (): void => {
			iframe.contentWindow?.focus();
			iframe.contentWindow?.print();
			setTimeout(() => {
				document.body.removeChild(iframe);
				resolve();
			}, 1000);
		};

		if (hasImage) {
			const clonedComponent = React.cloneElement(component, {
				onImageLoad: triggerPrint,
			});
			render(clonedComponent, rootElement);
		} else {
			render(component, rootElement);
			triggerPrint();
		}
	});
}
